import {
  GET_INBOX_MAILS_SUCCESS,
  GET_INBOX_MAILS_FAIL,
  SEND_MAIL_TO_USER_SUCCESS,
  SEND_MAIL_TO_USER_FAIL,
  SET_MAIL_READ_SUCCESS,
  SET_MAIL_READ_FAIL,
  GET_IMPORTANT_MAILS_SUCCESS,
  GET_IMPORTANT_MAILS_FAIL,
  GET_SENT_MAILS_SUCCESS,
  GET_SENT_MAILS_FAIL,
  GET_DRAFT_MAILS_SUCCESS,
  GET_DRAFT_MAILS_FAIL,
  GET_PARTICIPANT_EMAILS_SUCCESS,
  GET_PARTICIPANT_EMAILS_FAIL,
  REPLY_TO_EMAIL_SUCCESS,
  REPLY_TO_EMAIL_FAIL,
  ADD_EMAIL_SIGN_SUCCESS,
  ADD_EMAIL_SIGN_FAIL,
  FREE_EMAIL_NOTIFICATIONS_SUCCESS,
  FREE_EMAIL_NOTIFICATIONS_FAIL,
  GET_STORED_EMAILS_SUCCESS,
  GET_STORED_EMAILS_FAIL,
  GET_ADDRESS_BOOK_SUCCESS,
  GET_ADDRESS_BOOK_FAIL,
  REMOVE_ADDRESS_BOOK_EMAIL_SUCCESS,
  REMOVE_ADDRESS_BOOK_EMAIL_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  successRes: [],
  sentRes: [],
  inboxmails: [],
  starredmails: [],
  importantmails: [],
  draftmails: [],
  sentmails: [],
  trashmails: [],
  participantMails: [],
  error: {},
  readRes: [],
  emailSignRes: [],
  emails: [],
  addressBookList: [],
  res: [],
};

const Mails = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REMOVE_ADDRESS_BOOK_EMAIL_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case REMOVE_ADDRESS_BOOK_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ADDRESS_BOOK_SUCCESS:
      return {
        ...state,
        addressBookList: action.payload,
      };

    case GET_ADDRESS_BOOK_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_STORED_EMAILS_SUCCESS:
      return {
        ...state,
        emails: action.payload,
      };

    case GET_STORED_EMAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_EMAIL_SIGN_SUCCESS:
      return {
        ...state,
        sentRes: action.payload,
      };

    case ADD_EMAIL_SIGN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case FREE_EMAIL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        successRes: action.payload,
      };

    case FREE_EMAIL_NOTIFICATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REPLY_TO_EMAIL_SUCCESS:
      return {
        ...state,
        sentRes: action.payload,
      };

    case REPLY_TO_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_INBOX_MAILS_SUCCESS:
      return {
        ...state,
        inboxmails: action.payload,
      };

    case GET_INBOX_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case SEND_MAIL_TO_USER_SUCCESS:
      return {
        ...state,
        sentRes: action.payload,
      };

    case SEND_MAIL_TO_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case SET_MAIL_READ_SUCCESS:
      return {
        ...state,
        readRes: action.payload,
      };

    case SET_MAIL_READ_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_IMPORTANT_MAILS_SUCCESS:
      return {
        ...state,
        importantmails: action.payload,
      };

    case GET_IMPORTANT_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PARTICIPANT_EMAILS_SUCCESS:
      return {
        ...state,
        participantMails: action.payload,
      };

    case GET_PARTICIPANT_EMAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_DRAFT_MAILS_SUCCESS:
      return {
        ...state,
        draftmails: action.payload,
      };

    case GET_DRAFT_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_SENT_MAILS_SUCCESS:
      return {
        ...state,
        sentmails: action.payload,
      };

    case GET_SENT_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Mails;
